import { useMemo } from 'react';
import type { Animatronic } from '../types/animatronic';
import type { SortOption } from '../components/filters/SortSelect';

export function useSortedAnimatronics(
  animatronics: Animatronic[], 
  sortBy: SortOption,
  reverse: boolean = false
) {
  return useMemo(() => {
    const sorted = [...animatronics];

    // Define sort function based on sort type
    const getSortValue = (a: Animatronic, b: Animatronic): number => {
      switch (sortBy) {
        case 'alphabetical':
          return a.name.localeCompare(b.name);
        case 'favorite':
          return (b.elo_favorite || 1000) - (a.elo_favorite || 1000);
        case 'scarier':
          return (b.elo_scarier || 1000) - (a.elo_scarier || 1000);
        case 'cuter':
          return (b.elo_cuter || 1000) - (a.elo_cuter || 1000);
        case 'technical':
          return (b.elo_technical || 1000) - (a.elo_technical || 1000);
        case 'year':
          return b.year - a.year;
        default:
          return 0;
      }
    };

    // Sort array
    sorted.sort((a, b) => {
      const sortValue = getSortValue(a, b);
      return reverse ? -sortValue : sortValue;
    });

    return sorted;
  }, [animatronics, sortBy, reverse]);
}